import React, { useEffect, useState } from "react";
import ContentHeader from '../../components/ContentHeader'
import Loader from "../../components/Loader";
import Switch from "react-switch";
import Swal from "sweetalert2";
import axios from "axios";
import $ from 'jquery';
import "datatables.net-responsive-bs4";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-bs4/css/dataTables.bootstrap4.css";
import ImageNotFound from '../../assets/images/not-found.png';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const PageBlogs = () => {
    const [loading, setLoading] = useState(false);
    const [page_blog_id, setPageBlogId] = useState(0);
    const [blog_title, setBlogTitle] = useState('');
    const [blog_sub_title, setBlogSubTitle] = useState('');
    const [blog_image, setBlogImage] = useState('');
    const [section_blogs, setSectionBlogs] = useState([]);
    const ENDPOINT = process.env.REACT_APP_URL_ENDPOINT;
    const TITLEALERT = process.env.REACT_APP_TITLE_ALERT;
    const URLZFILES = process.env.REACT_APP_API_ZFILES;

    useEffect(() => {
        setTimeout(() => {
            $('.select2').select2({ width: "100%" });
        }, 100); 
        getAll();
    }, []);

    const getAll = async () => {
        setLoading(true);
        var table = $('.main').DataTable();
        table.destroy(); 
        await axios.get(ENDPOINT + "get-page-blog-all").then((response) => {
        setSectionBlogs(response.data.data);
        setTimeout(() => {
            $('.main').DataTable({
                searching: true,
                destroy: true,
                retrieve: true,
                pageLength: 10,
                responsive: true,
                autoWidth: true,
                paging: true,
                ordering: true,
                sortable: true,
                processing: false,
                serverSide: false,
                bInfo: true,
                language: {
                    "decimal": "",
                    "emptyTable": "",
                    "info": "Mostrando _START_ a _END_ de _TOTAL_ registros",
                    "infoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
                    "infoFiltered": "(filtrado de un total de _MAX_ registros)",
                    "infoPostFix": "",
                    "thousands": ",",
                    "lengthMenu": "Mostrar _MENU_ registros",
                    "loadingRecords": "Cargando...",
                    "processing": "Procesando...",
                    "search": "Buscar:",
                    "paginate": {
                        "first": "<i class='fa-solid fa-circle-chevron-left'></i>",
                        "last": "<i class='fa-solid fa-circle-chevron-right'></i>",
                        "next": "<i class='fas fa-arrow-circle-right'></i>",
                        "previous": "<i class='fas fa-arrow-circle-left'></i>"
                    },
                    "zeroRecords": "No hay registros",
                    "searchPlaceholder": "Buscar por noticia",
                },
            });
            setLoading(false);
        }, 100);
        })
        .catch(function (error) {
            setLoading(false);
            console.log(error);
        });
    };

    const handleNew = () => {
        clearField();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const form = new FormData();
        form.append("blog_title", blog_title);
        form.append("blog_sub_title", blog_sub_title);
        form.append("blog_image", blog_image);
        if (page_blog_id === 0) {
            await axios
                .post(ENDPOINT + "save-page-blog", form)
                .then((response) => {
                    getAll();
                    clearField();
                    setLoading(false);
                    $("#closemodal").trigger("click");
                    Swal.fire({
                        icon: "success",
                        title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                        showConfirmButton: false,
                        timer: 3000,
                        html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                        showClass: { popup: "animate__animated animate__fadeInDown" },
                        hideClass: { popup: "animate__animated animate__fadeOutUp" },
                    });
                })
                .catch(function (error) {
                    console.log(error);
                    setLoading(false);
                    Swal.fire({
                        icon: "error",
                        title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                        showConfirmButton: true,
                        timer: 3000,
                        html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                        showClass: { popup: "animate__animated animate__fadeInDown" },
                        hideClass: { popup: "animate__animated animate__fadeOutUp" },
                    });
                });
        } else {
            setLoading(true);
            await axios
            .put(ENDPOINT + "update-page-blog/" + page_blog_id, {
                blog_title: blog_title,
                blog_sub_title: blog_sub_title,
                blog_image: blog_image
            })
            .then((response) => {
                getAll();
                clearField();
                setLoading(false);
                $("#closemodal").trigger("click");
                Swal.fire({
                    icon: "success",
                    title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                    showConfirmButton: false,
                    timer: 3000,
                    html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                    showClass: { popup: "animate__animated animate__fadeInDown" },
                    hideClass: { popup: "animate__animated animate__fadeOutUp" },
                });
            })
            .catch(function (error) {
                console.log(error);
                setLoading(true);
                Swal.fire({
                    icon: "error",
                    title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                    showConfirmButton: true,
                    timer: 3000,
                    html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                    showClass: { popup: "animate__animated animate__fadeInDown" },
                    hideClass: { popup: "animate__animated animate__fadeOutUp" },
                });
            });
        }
    };

    const clearField = () => {
        setPageBlogId(0);
        setBlogTitle('');
        setBlogSubTitle('');
        setBlogImage('');
    };

    const toggleSwitch = async (val) => {
        setLoading(true);
        await axios
            .put(ENDPOINT + "get-page-blog-status/" + val)
            .then((response) => {
                getAll();
                setLoading(false);
                Swal.fire({
                    icon: "success",
                    title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                    showConfirmButton: false,
                    timer: 3000,
                    html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                    showClass: { popup: "animate__animated animate__fadeInDown" },
                    hideClass: { popup: "animate__animated animate__fadeOutUp" },
                });
            })
            .catch(function (error) {
                console.log(error);
                setLoading(false);
                Swal.fire({
                    icon: "error",
                    title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                    showConfirmButton: true,
                    timer: 3000,
                    html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                    showClass: { popup: "animate__animated animate__fadeInDown" },
                    hideClass: { popup: "animate__animated animate__fadeOutUp" },
                });
            });
    };

    const handleEdit = async (id) => {
        setLoading(true);
        await axios
            .get(ENDPOINT + "get-page-blog/" + id)
            .then((response) => {
                setLoading(false);
                setPageBlogId(response.data.data.page_blog_id);
                setBlogTitle(response.data.data.blog_title);
                setBlogSubTitle(response.data.data.blog_sub_title);
                setBlogImage(response.data.data.blog_image);
            })
            .catch(function (error) {
                console.log(error);
                setLoading(false);
            });
    };

    const handleDelete = (id, name) => {
        Swal.fire({
            title: `¿Desea eliminar el registro [ ${name} ] ?`,
            text: "No podrá recuperarlo",
            icon: "warning",
            confirmButtonText: "Sí, eliminarlo",
            confirmButtonColor: "#469408",
            showCancelButton: true,
            cancelButtonColor: "#c71c22",
            cancelButtonText: "No",
        }).then((result) => {
            if (result.isConfirmed) {
                setLoading(true);
                axios
                .delete(ENDPOINT + "delete-page-blog/" + id).then((response) => {
                    getAll();
                    setLoading(false);
                    Swal.fire({
                        icon: "success",
                        title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                        showConfirmButton: false,
                        timer: 3000,
                        html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                        showClass: { popup: "animate__animated animate__fadeInDown" },
                        hideClass: { popup: "animate__animated animate__fadeOutUp" },
                    });
                })
                .catch(function (error) {
                    setLoading(false);
                    Swal.fire({
                        icon: "error",
                        title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                        showConfirmButton: true,
                        timer: 3000,
                        html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                        showClass: { popup: "animate__animated animate__fadeInDown" },
                        hideClass: { popup: "animate__animated animate__fadeOutUp" },
                    });
                });
            }
        });
    };

    const handleFileChange = async (e) => {
        setLoading(true);
        const form = new FormData();
        form.append('file', e.target.files[0]);
        form.append('destination', 'zfiles/blogs/');
        await axios.post(ENDPOINT + 'upload-page-blog', form, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(response => {
            setBlogImage(response.data.data.pathFile);
            setLoading(false);
            Swal.fire({
                icon: "success",
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: false,
                timer: 1000,
                html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                showClass: { popup: "animate__animated animate__fadeInDown" },
                hideClass: { popup: "animate__animated animate__fadeOutUp" },
            });
        }).catch(function (error) {
            console.log(error)
            setLoading(false);
            Swal.fire({
                icon: 'error',
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: true,
                html: '<div class="text-custom-alert">' + error.response.data.msg + '</div>',
                showClass: { popup: 'animate__animated animate__fadeInDown' },
                hideClass: { popup: 'animate__animated animate__fadeOutUp' }
            })
        });
    };

    const resetPage = () => {
        window.location.reload();
    };

    const formatDateTime = (dateTimeString) => {
        if (!dateTimeString) return "";
        const date = new Date(dateTimeString);
        
        // Array de meses en español
        const meses = [
            'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
            'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
        ];
        
        const dia = date.getDate();
        const mes = meses[date.getMonth()];
        const año = date.getFullYear();
        
        // Formatear hora
        const hours = date.getHours();
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const ampm = hours >= 12 ? 'PM' : 'AM';
        const hours12 = (hours % 12 || 12).toString().padStart(2, '0');

        return `${dia} de ${mes} de ${año} a las ${hours12}:${minutes} ${ampm}`;
    };

    const modules = {
        toolbar: [
            [{ 'header': [1, 2, false] }],
            ['bold', 'italic', 'underline','strike', 'blockquote'],
            [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
            ['link', 'image'],
            ['clean']
        ],
    };
    
    const formats = [
        'header',
        'bold', 'italic', 'underline', 'strike', 'blockquote',
        'list', 'bullet', 'indent',
        'link', 'image'
    ];

    return (
        <>
            {loading && <Loader />}
            <div className="modal fade" id="modal-default" aria-labelledby="modal-default" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">
                        <div className="modal-header bg-header-modal">
                            <h4 className="modal-title">Blog</h4>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <form id="formulario" onSubmit={handleSubmit}>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-12 col-sm-12 mt-3">
                                        <div className="form-group">
                                            <label htmlFor="blog_title" className="col-form-label col-form-label-sm">
                                                Titulo
                                            </label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm`}
                                                placeholder="Ingrese titulo"
                                                id="blog_title"
                                                name="blog_title"
                                                value={blog_title}
                                                onChange={(e) => setBlogTitle(e.target.value)}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-12 mt-3">
                                        <div className="form-group">
                                            <label htmlFor="blog_sub_title" className="col-form-label col-form-label-sm">
                                                Descripción
                                            </label>
                                            <ReactQuill 
                                                theme="snow" 
                                                value={blog_sub_title} 
                                                onChange={setBlogSubTitle} 
                                                modules={modules}
                                                formats={formats}
                                                placeholder={'Ingrese descripción del blog'}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-12 mt-3">
                                        <div className="form-group">
                                            <label htmlFor="blog_image" className="col-form-label col-form-label-sm">
                                                Imagen (Recomendación: 600px por 375px)
                                            </label>
                                            <br/>
                                            <input 
                                                type="file" 
                                                name="file" 
                                                onChange={handleFileChange} 
                                            />
                                        </div>
                                        <img 
                                            className="rounded border border-secondary img-fluid"
                                            width={350}
                                            height={185} 
                                            src={blog_image ? URLZFILES+blog_image : ImageNotFound} 
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="submit"
                                    className="btn btn-success">
                                    <i className="fa-regular fa-floppy-disk me-1"></i>
                                    {page_blog_id === 0 ? "Guardar" : "Actualizar"}
                                </button>
                                <button
                                    id="closemodal"
                                    type="button"
                                    className="btn btn-danger"
                                    data-bs-dismiss="modal">
                                    <i className="fa-solid fa-ban me-1"></i> Cancelar
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
    
            <div className="container-fluid">
                <ContentHeader  title="Administración Página Blogs" />
            </div>
        
            <div className="container-fluid">
                <div className="card">
                    <div className="card-header">
                        <div className="indications-header row">
                            <div className="col-md-7">
                                <h4 className="card-title m-0 page-title">
                                    <i className="bi bi-pencil-square me-2"></i> Blogs
                                </h4>
                            </div>
                            <div className="col-md-5 text-end">
                                <button
                                    onClick={handleNew}
                                    data-bs-toggle="modal"
                                    data-bs-target="#modal-default"
                                    className="btn btn-success btn-sm me-1"
                                >
                                    <i className="fas fa-plus-circle me-1"></i> Agregar
                                </button>
                                <button
                                    onClick={resetPage}
                                    className="btn btn-info btn-sm me-1"
                                    type="button">
                                    <i className="fa fa-refresh me-1"></i> Recargar
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <table className="table table-hover table-striped main table-responsive">
                            <thead>
                                <tr>
                                    <th width="8%" className="text-center">#</th>
                                    <th className="text-left">Titulo</th>
                                    <th className="text-left">Descripción</th>
                                    <th className="text-center">Fecha Publicación</th>
                                    <th className="text-center">Imagen</th>
                                    <th width="10%" className="text-center">Estado</th>
                                    <th width="10%" className="text-center">Opciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {section_blogs.map((item, index) => (
                                    <tr key={index}>
                                        <td>
                                            <kbd># {item.page_blog_id}</kbd>
                                        </td>
                                        <td>
                                            {item.blog_title}
                                        </td>
                                        <td>
                                            <div dangerouslySetInnerHTML={{ __html: item.blog_sub_title }}/>
                                        </td>
                                        <td className="text-center text-muted">
                                            {formatDateTime(item.date_created)}
                                        </td>
                                        <td className="text-center">
                                            <img
                                                className="rounded border border-secondary img-fluid" 
                                                width={150}
                                                height={80}
                                                rounded
                                                src={item.blog_image ? URLZFILES + item.blog_image : ImageNotFound}
                                                alt="banner"
                                            />
                                        </td>
                                        <td className="text-center">
                                            <div data-toggle="tooltip" data-placement="top" title="Estado">
                                                <Switch
                                                    checkedIcon={false}
                                                    uncheckedIcon={false}
                                                    checked={item.status === 1 ? true : false}
                                                    onChange={() => toggleSwitch(item.page_blog_id)}
                                                />
                                            </div>
                                        </td>
                                        <td className="text-center">
                                            <div>
                                                <button
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#modal-default"
                                                    className="btn-sm btn btn-warning me-1"
                                                    onClick={() => handleEdit(item.page_blog_id)}
                                                >
                                                    <i className="fa-solid fa-pen-to-square"></i>
                                                </button>
                                                <button
                                                    className="btn-sm btn btn-danger me-1"
                                                    onClick={() => handleDelete(item.page_blog_id, item.blog_title)}
                                                >
                                                    <i className="fa-solid fa-trash-can"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PageBlogs;